/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForAzure extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForAzure");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForAzure.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForAzure>): ServiceAccountNativeDetailsBaseForAzure {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForAzure(), model);
        ServiceAccountNativeDetailsBaseForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForAzure>): ServiceAccountNativeDetailsBaseForAzure {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForAzure.newInstance(<ServiceAccountNativeDetailsBaseForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForAzure) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForAzure): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Azure Cloud Type. This is a required field.
     */
    cloud_type: models.AzureCloudType;

}
